
import { callUIAPI } from './apiUtils';
import * as apiConstants from './apiUtilsConstants';

const BASE_PATH = 'bo/system-settings';

export const getSystemSettings = async () => {
  const response = await callUIAPI(BASE_PATH, null, apiConstants.METHOD_GET, true);
  return response.data.list;
};

export const updateSystemSetting = async (id, value) => {
  const response = await callUIAPI(
    `${BASE_PATH}/${id}`,
    { value: String(value) },
    apiConstants.METHOD_PUT,
    true
  );
  return response.data.item;
};

export const resetSystemSetting = async (id) => {
  const response = await callUIAPI(
    `${BASE_PATH}/${id}/reset`,
    {},
    apiConstants.METHOD_POST,
    true
  );
  return response.data.item;
};